export const Tag = ({ tagName, tagStyle, className, ...props }) => {
  return (
    <span className={`p-2 px-3  ${className}`} style={tagStyle} {...props}>
      {tagName}
    </span>
  );
};

export const SuccessTag = ({ tagName, className, width, ...props }) => {
  return (
    <span
      className={`p-2 px-3  ${className}`}
      style={{
        background: "#EDF8F3",
        color: "#1BBB6B",
        fontSize: "11px",
        width: width,
      }}
      {...props}
    >
      {tagName}
    </span>
  );
};

export const PendingTag = ({ tagName, className, width, ...props }) => {
  return (
    <span
      className={`p-2 px-3  ${className}`}
      style={{
        background: "#FDEBD8",
        color: "#F7A64F",
        fontSize: "11px",
        width: width,
      }}
      {...props}
    >
      {tagName}
    </span>
  );
};

export const FailedTag = ({ tagName, className, width, ...props }) => {
  return (
    <span
      className={`p-2 px-3  ${className}`}
      style={{
        background: "#FED7D8",
        color: "#FC555B",
        fontSize: "11px",
        width: width,
      }}
      {...props}
    >
      {tagName}
    </span>
  );
};
